import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import PageDescriptionDenuncias from '../../PageDescription/Denuncias';
// import imgOrg from '../../../assets/img/organograma/img-org.png';
// import icoPDf from '../../../assets/img/ico-pdf.svg';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';

class Denuncias extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<ErrorBoundary><BannerSingle image={"Denuncias"} page={"canal-de-denuncia"} /></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PageDescriptionDenuncias page={"canal-de-denuncia"}/></ErrorBoundary>
					{/* Content page */}
					
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Denuncias;